import React from 'react';
import Layout from './layout/base';

const App: React.FC = () => {
  return (
    <Layout />
  );
}

export default App;
